// @flow
import * as React from 'react';
import Modal from 'react-modal';
import Link from 'components/Link';
import Text from 'components/Text';
import EventTracking from 'lib/EventTracking';
import Checkbox from 'components/Checkbox';
import Fieldset from 'components/Fieldset';
import LinkConstants from 'constants/LinkConstants';
import DeleteAccountConfirmationDialog from 'settings/components/DeleteAccountConfirmationDialog';

import './styles/PIIConsentForm.scss';

type State = {
  showAccountDeletionModal: boolean,
};

class PIIConsentForm extends React.Component<{}, State> {
  state: State = {
    showAccountDeletionModal: false,
  };

  componentDidUpdate(prevProps: *, prevState: State) {
    if (!prevState.showAccountDeletionModal && this.state.showAccountDeletionModal) {
      EventTracking.trackKey('account_settings.pii_consent.toggle.click');
    }
  }

  handleAccountDeleted = () => {
    window.location = LinkConstants.MARKETING;
  };

  showConfirmationDialog = () => this.setState({ showAccountDeletionModal: true });
  hideConfirmationDialog = () => this.setState({ showAccountDeletionModal: false });

  render() {
    return (
      <React.Fragment>
        <Modal isOpen={this.state.showAccountDeletionModal}>
          <DeleteAccountConfirmationDialog
            reason="pii_consent"
            title="Delete your account"
            onDeleted={this.handleAccountDeleted}
            sourceEventKey="from_pii_consent_toggle"
            onRequestHide={this.hideConfirmationDialog}
            subtext="Remind cannot provide our service without collecting your information."
          />
        </Modal>
        <Fieldset legend="Data practices">
          <div className="PIIConsentForm">
            <Text element="div">
              Remind collects information from you in order to provide our service. This includes
              your name, your school, your email, and your phone number.{' '}
              <Link target="_blank" href={LinkConstants.DATA_PRACTICE}>
                Learn more
              </Link>
            </Text>

            <Text element="div" color="apple">
              If you decline, you will no longer be able to use Remind. Your Remind account will be
              deleted.
            </Text>

            <Checkbox
              readOnly
              checked
              label="I accept these terms"
              onClick={this.showConfirmationDialog}
            />
          </div>
        </Fieldset>
      </React.Fragment>
    );
  }
}

export default PIIConsentForm;
